module.exports = __webpack_public_path__ + "static/media/delete.ba6720fb.svg";